<template>
  <div class="vcl-busy" :style="widgetStyles">
    <div v-if="busy" class="vcl-busy__container">
      <VpIcon icon="loading" spin />
    </div>
  </div>
</template>

<script>
import VpIcon from '../vp-icon/VpIcon.vue';

export default {
  name: "VpBusy",
  components: {
    VpIcon,
  },
  props: {
    styles: { type: Object, default: () => ({}) },
  },
  data: () => ({
    busy: false,
  }),
  computed: {
    widgetStyles() {
      return {
        "--busy-width": this.styles.width || "100%",
        "--busy-height": this.styles.height || "100%",
        "--busy-index": this.styles.index || "9999",
        "--busy-position-top": this.styles.top || "0",
        "--busy-position-left": this.styles.left || "0",
        "--busy-position": this.styles.position || "absolute",
        "--busy-icon-margin": this.styles.margin || "0",
        "--busy-icon-size": this.styles.fontSize || "100px",
      };
    },
  },
  methods: {
    toggle(value) {
      this.busy = value;
    },
  },
};
</script>

<style lang="scss" scoped>
.vcl-busy {
  &__container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: var(--busy-width);
    height: var(--busy-height);
    z-index: var(--busy-index);
    top: var(--busy-position-top);
    left: var(--busy-position-left);
    position: var(--busy-position) !important;
  }

  svg {
    margin: var(--busy-icon-margin) !important;
    font-size: var(--busy-icon-size);
  }
}
</style>
